import {useContext} from 'react'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {PanelBasic} from '@adv-mt/mt-panel-basic'
import SectionBasic from '@adv-mt/mt-section-basic'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const BASE_CLASS = `mt-SectionDetailInstantOffer`

const SectionDetailInstantOffer = () => {
  const {domain, i18n} = useContext(Context)
  const {INSTANT_OFFER_STANDALONE_PATTERN} = domain.get('config').get('page')

  return (
    <SectionBasic title={i18n.t('INSTANT_OFFER.DETAIL_PANEL.SAVE_MONEY')}>
      <PanelBasic>
        <div className={BASE_CLASS}>
          <div>
            <TitleBasic
              as={titleBasicTags.h2}
              size={titleBasicSizes.xs}
              title={i18n.t('INSTANT_OFFER.DETAIL_PANEL.SELL_YOUR_CAR')}
            />
            <p className={`${BASE_CLASS}-titleDescription`}>{i18n.t('INSTANT_OFFER.DETAIL_PANEL.SELL_TO_DEALER')}</p>
          </div>
          <div>
            <AtomButton
              design={atomButtonDesigns.OUTLINE}
              fullWidth
              href={`${INSTANT_OFFER_STANDALONE_PATTERN}?ipromo=c2b-detail-service_module`}
              link
              rel="noreferrer"
              shape={atomButtonShapes.CIRCULAR}
              target="_blank"
            >
              <span>{i18n.t(`HOME_SERVICES_TRADING_COCHES_SELL_TEXT`)}</span>
            </AtomButton>
          </div>
        </div>
      </PanelBasic>
    </SectionBasic>
  )
}

SectionDetailInstantOffer.displayName = 'SectionDetailInstantOffer'
export default SectionDetailInstantOffer
